import { render, staticRenderFns } from "./CardChallenge.vue?vue&type=template&id=c168ad86"
import script from "./CardChallenge.vue?vue&type=script&lang=js"
export * from "./CardChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports